
import { useApi } from '@/hooks/use_api';
import { useLoader } from '@/hooks/use_loader';
import { UseActionExecuteType } from '@/models/action_base';

import { useState } from './use_state';

/**
 * キャンペーン情報を取得して、データをローカルに保持する
 */
export function useActionCommonUpdate(): UseActionExecuteType {
  const api = useApi();
  const loader = useLoader();
  const stateData = useState();

  return async () => {
    try {
      loader.start();
      const response = await api.getCommon();
      stateData.value.common = JSON.stringify(response.dataJson);
      return false;
    } finally {
      loader.stop();
    }
  };
}
